// Centered max-width for prose/reading content (questions, answers, notes).
// ~70-80 chars per line is the comfortable reading norm (Medium/Notion/Stack Overflow).
export const READING_COLUMN_MAX = 720;
// Legacy centered phone-column width. Below the desktop breakpoint the app
// stays capped to this (unchanged phone/tablet/WebView experience). Only
// desktop lifts the cap to use the full window.
// export const NON_DESKTOP_MAX_WIDTH = 860;
export const NON_DESKTOP_MAX_WIDTH = 1120;
// Outer cap for the main content column on desktop (same as the legacy phone
// column width so the familiar reading width is preserved beside the sidebar).
export const CONTENT_REGION_MAX = NON_DESKTOP_MAX_WIDTH;
// Persistent desktop top navbar height.
export const DESKTOP_NAVBAR_HEIGHT = 56;
// Persistent desktop left sidebar width (legacy; navbar replaced sidebar).
export const SIDEBAR_WIDTH = 240;
// Master-detail list pane width on desktop.
export const LIST_PANE_WIDTH = 400;
export const masterDetailListPaneStyle = {
    width: LIST_PANE_WIDTH,
};
export const masterDetailReadingPaneStyle = {
    flex: 1,
    overflow: 'hidden',
};
// Wider desktop content cap for master-detail layouts (list pane + reading column).
export const CONTENT_REGION_WIDE_MAX = LIST_PANE_WIDTH + READING_COLUMN_MAX;
export const PageContentWidth = {
    DEFAULT: CONTENT_REGION_MAX,
    MASTER_DETAIL: CONTENT_REGION_WIDE_MAX,
};
// Desktop breakpoint: at/above this window width the web app uses the
// full-screen desktop shell (sidebar + split panes). Below it, phone/tablet
// layout is preserved unchanged.
export const DESKTOP_MIN_WIDTH = 1024;
